import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-assets-exchange-opt-icon",
  "use": "icon-assets-exchange-opt-icon-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-assets-exchange-opt-icon\">\n<path d=\"M10.52 5.96659L13 3.48659L10.52 1.00659M1 3.48659H13M3.48 8.03326L1 10.5133L3.48 12.9933M13 10.5133H1\" stroke=\"#1752FC\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol